module.exports = __webpack_public_path__ + "img/car_02.6af3be45.png";